<template>
    <div class="app">
    <MusicCase :mobileActived="mobile.actived" v-if="music == true" ref="musicCase"/>
    <router-view v-slot ="{Component}">
        <Transition mode="out-in"
        :css="false"
        @before-leave="onBeforeLeave"
        @leave="onLeave"
        @after-leave="onAfterLeave"
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @after-enter="onAfterEnter"
        >
            <component :is="Component"/>
        </Transition>
    </router-view>
    </div>
</template>

<script>
import { computed } from '@vue/runtime-core'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import MusicCase from '@/components/MusicCase.vue'
export default {
    name: "App",
    components: {
        MusicCase
    },
    data(){
        return{
            music: true,
            mobile: {
                size: 760,
                actived: undefined
            },
            color: {
                primary: "white",
                secondary: "black"
            },
            currentTime: undefined,
        }
    },
    provide() {
        return{
            mobileSize: computed(() => this.mobile.size),
            mobileActived: computed(() => this.mobile.actived),
            primaryColor: computed(() => this.color.primary),
            secondaryColor: computed(() => this.color.secondary),
        }
    },
    watch: {
        //! Changer le titre des pages selon la route ciblé
        "$route"(to){
            document.title = to.meta.title
        }
    },
    methods: {
        //! Avant de quitter la page courante
        onBeforeLeave(el) {
           //: SI LA PAGE EST DEJA CHARGEE
            if(this.$store.state.load !== false){
                //: TOUTES LES ROUTES SAUF "PROJET"
                if(this.$route.meta.text !== "Projet"){
                    //- OUVRIR LA TRANSITION
                    const transitionPage = el.children.transitionpage
                    transitionPage.style.display = "flex"
                    transitionPage.style.transform = "translate(0px, 0px)"
                    
                    //- ON MET LE NOM DE LA ROUTE SUIVANTE
                    const trText = el.children.transitionpage.children[0].children[0]
                    trText.textContent = this.$route.meta.text
                //: ROUTE "PROJET"
                } else {
                    const id = el.id
                    const parentProject = document.querySelector(`#${id} .project__list__contain`)
                    //- Récupérer l'index du projet ciblé
                    var index
                    for (let i = 0; i < parentProject.children.length; i++) {
                        if(parentProject.children[i].classList.contains("current-click-choice") == true){
                            index = i
                            break
                        }
                    }
                    const video = document.querySelectorAll(".project__list video")[index]
                    video.pause()
                    this.currentTime = video.currentTime
                }
            
            } 
            //: Blocage du scroll
            this.$store.dispatch("blockScrollStyle")
          
        },
        //! Animation de la page courante
        onLeave(el, done) {
            if(this.music == true){
                //* On met la musique courante en pause
                this.$refs.musicCase.allPause("app")
                //* Sécurité, au cas où une view ne détruirait pas tout les ScrollTriggers
                if(ScrollTrigger.getAll().length !== 0){
                    ScrollTrigger.getAll().forEach((element) => {
                        element.kill()
                    })
                }
            }
            //: SI LA PAGE EST DEJA CHARGEE
            if(this.$store.state.load !== false){
                
                //: TOUTES LES ROUTES SAUF "PROJET"
                if(this.$route.meta.text !== "Projet"){
                
                    //- APPARITION
                    const gsap = this.gsap
                    const timeline = gsap.timeline({
                        onComplete(){
                            done()
                        }
                    })
                    const transitionPage = el.children.transitionpage
                    //: VALABE SEULEMENT SUR "DESKTOP"
                    if(this.mobile.actived == false){
                        
                        timeline.from(transitionPage, {
                            x: "100%",
                            duration: this.$store.state.transition.page.duration.apparition,
                            ease: this.$store.state.transition.page.ease
                        })
                    }
                    timeline.set(transitionPage, {
                        display: "none",
                        x: 0
                    })
                //: ROUTE "PROJET"
                } else {
                    
                    const gsap = this.gsap
                    const id = el.id
                    const parentProject = document.querySelector(`#${id} .project__list__contain`)
                    //- Récupérer l'index du projet ciblé
                    var index
                    for (let i = 0; i < parentProject.children.length; i++) {
                        if(parentProject.children[i].classList.contains("current-click-choice") == true){
                            index = i
                            break
                        }
                    }
                    const itemIndex = index + 1
                    //- Récupérer le translateX du parent
                    const parentProjectMatrix = parentProject.dataset.translate
                    const matrixView = new WebKitCSSMatrix(parentProjectMatrix);
                    const parentTranslateX = matrixView.m41
                    //- Récupérer les tailles qui définissent la section
                    const itemMarginRight = gsap.getProperty(".project__list__contain__item", "marginRight")
                    const mediaWidth = gsap.getProperty(".project__list__contain__item__media", "width")
                    const mediaHeight = gsap.getProperty(".project__list__contain__item__media", "height")
                    const marge = (window.innerWidth - mediaWidth) / 2
                    const coeff = itemMarginRight / marge - 1
                    //- Valeur de translateX
                    let translateX
                    //: VALABE SEULEMENT SUR "DESKTOP"
                    if(this.mobile.actived == false){
                        translateX = -1 * ((itemIndex * (itemMarginRight + mediaWidth)) + parentTranslateX)
                    //: VALABE SEULEMENT SUR "MOBILE"
                    } else {
                        translateX = -1 * (parentTranslateX + (window.innerWidth * itemIndex) - marge - (marge * coeff * (itemIndex - 1)))
                    }
                    //- Valeur du scale
                    const mediaEntryClamp = {ftMin: 40, ftMax: 80, unit: "px", wdMin: 1000, wdMax: 2000}
                    const mediaEntryPaddingXClamp = gsap.utils.clamp(mediaEntryClamp.ftMin, mediaEntryClamp.ftMax)
                    const mediaEntryPaddingX = mediaEntryPaddingXClamp(mediaEntryClamp.ftMax + (window.innerWidth - mediaEntryClamp.wdMax) / ((mediaEntryClamp.wdMax - mediaEntryClamp.wdMin) / (mediaEntryClamp.ftMax - mediaEntryClamp.ftMin)))
                    let scale
                    //: VALABE SEULEMENT SUR "DESKTOP"
                    if(this.mobile.actived == false){
                        scale = (window.innerWidth - (2 * mediaEntryPaddingX)) / mediaWidth
                    //: VALABLE SEULEMENT SUR "MOBILE"
                    } else {
                        //? Video (object-fit: cover) | width --> 105vw / height --> 80vh dans "EntryVideo"
                        scale = (window.innerWidth * 1.05) / mediaWidth
                    }
                    //- TRANSLATEY --> ON AMENE LA VIDEO A 0 + MONTER
                    const projectNameHeight = gsap.getProperty(".project__list__contain__item__text", "height") + gsap.getProperty(".project__list__contain__item__text", "marginTop")
                    const decalageParent = parentProject.getBoundingClientRect().height - parentProject.getBoundingClientRect().bottom
                    const translate0 = ((projectNameHeight * scale) / 2) + (mediaHeight * scale) + ((window.innerHeight - (mediaHeight * scale)) * 0.5) + decalageParent
                    const translateY = translate0 - (window.innerHeight * (this.$store.state.transition.project.up / 100))
                    
                    //- Liste des éléments à faire disparaître
                    const listToHidden = [
                        "#landingpage",
                        "#stacktype",
                        ".project__clause", 
                        ".project__list__contain__item__text", 
                        ".project__list__contain__item:not(.current-click-choice)"
                    ]
                    //- TIMELINE
                    const timeline = gsap.timeline({
                        onComplete(){
                            done()
                        }
                    })
                    //- Transform origin au "centre"
                    timeline.set(".current-click-choice", {
                        transformOrigin: "center center",
                        clipPath: "inset(1px, 1px)"
                    })
                    //- On désactive "overflow : hidden" au cas où le dernier media serait ciblé dans la partie suivante
                    timeline.set("#projectshow", {
                        overflow: "visible"
                    })
                    //- Disparition des éléments cible
                    timeline.addLabel("opacity")
                    timeline.to(listToHidden, {
                        opacity: 0,
                        duration: this.$store.state.transition.project.duration.other
                    }, "opacity")
                    //- Transformation de la video
                    timeline.addLabel("transform", "<")
                    timeline.to(".current-click-choice", {
                        x: `${translateX}px`,
                        y: `${translateY}${mediaEntryClamp.unit}`,
                        scale: scale,
                        duration: this.$store.state.transition.project.duration.video,
                    }, "transform")
                    //- Disparition du filtre
                    timeline.addLabel("filter", "<")
                    timeline.to(".current-click-choice .project__list__contain__item__media__filter", {
                        opacity: 0,
                        duration: this.$store.state.transition.project.duration.video,
                    }, "filter")
                    //: VALABE SEULEMENT SUR "DESKTOP"
                    if(this.mobile.actived == false){
                        
                        //- Rotation
                        timeline.to(".current-click-choice", {
                            rotate: 3,
                            duration: this.$store.state.transition.project.duration.video,
                        }, "transform")
                    
                    } 
                    //: VALABE SEULEMENT SUR "MOBILE"
                    if(this.mobile.actived == true){
                        //? Video (object-fit: cover) | width --> 105vw / height --> 80vh dans "EntryVideo"
                        const translateYVideo = -1 * (((((mediaHeight * scale) - (window.innerHeight * 0.8)) / 2) / (mediaHeight * scale)) * 100)
                        
                        if(translateYVideo < 0){
                            //- TransformY à l'intérieur de la vidéo seul
                            timeline.to([".current-click-choice video", ".current-click-choice .project__list__contain__item__media__filter"], {
                                y: `${translateYVideo}%`,
                                duration: this.$store.state.transition.project.duration.video,
                            }, `<`)
                        }
                
                    } 
                    
                }
            } 
            
        },
        //! Après l'aniamtion de la page courante
        onAfterLeave(el){
        },  
        //! Avant de rentrer dans la page ciblé
        onBeforeEnter(el) {
            //: SI LA PAGE EST DEJA CHARGEE ...
            if(this.$store.state.load !== false){
                
                //: TOUTES LES ROUTES SAUF "PROJET"
                if(this.$route.meta.text !== "Projet"){
                    //- OUVRIR LA TRANSITION
                    const transitionPage = el.children.transitionpage
                    transitionPage.style.display = "flex"
                    transitionPage.style.transform = "translate(0px, 0px)"
                    //- ON MET LE NOM DE LA ROUTE SUIVANTE
                    const trText = el.children.transitionpage.children[0].children[0]
                    trText.textContent = this.$route.meta.text
                }
            }
        },
        
        //! Animation dans la page ciblé
        onEnter(el, done) {
            
            //: SI LA PAGE EST DEJA CHARGEE
            if(this.$store.state.load !== false){
                
                //: TOUTES LES ROUTES SAUF "PROJET"
                if(this.$route.meta.text !== "Projet"){
                
                    //- DISPARITION
                    const gsap = this.gsap
                    const timeline = gsap.timeline({
                        onComplete(){
                            done()
                        }
                    })
                    const transitionPage = el.children.transitionpage
                    //: VALABE SEULEMENT SUR "DESKTOP"
                    if(this.mobile.actived == false){
                        timeline.delay(this.$store.state.transition.page.duration.focusDesktop)
                    } else {
                        timeline.delay(this.$store.state.transition.page.duration.focusMobile)
                    }
                    timeline.to(transitionPage, {
                        x: "-100%",
                        duration: this.$store.state.transition.page.duration.apparition,
                        ease: this.$store.state.transition.page.ease
                    })
                    timeline.set(transitionPage, {
                        display: "none",
                        x: 0
                    })
                //: ROUTE "PROJET"
                } else {
                    const gsap = this.gsap
                    const entryCurrent = document.querySelector(".entry_current")
                    const entryCurrentName = document.querySelector(".entry_current .entry__name")
                    const entryCurrentVideo = document.querySelector(".entry_current .entry__media__item")
                    const info = document.querySelector(".header")
                    //- On fige la vidéo
                    entryCurrentVideo.pause()
                    entryCurrentVideo.currentTime = this.currentTime
                    //- TRANSLATEY --> ON RAMENE LA VIDEO A 0 + MONTER
                    const entryCurrenPaddingTop = gsap.getProperty(entryCurrent, "paddingTop")
                    const translate0 = window.innerHeight - Math.abs(entryCurrenPaddingTop)
                    const translateY = translate0 - (window.innerHeight * (this.$store.state.transition.project.up / 100))
                    //- TIMELINE
                    const timeline = gsap.timeline({
                        onComplete(){
                            done()
                        }
                    })
                    //- Apparition des éléments
                    timeline.addLabel("apparition")
                    timeline.from(info, {
                        opacity: 0,
                        duration: this.$store.state.transition.project.duration.other
                    }, "apparition")
                    //- Descente du la vidéo d'entré
                    timeline.addLabel("descente", "<")
                    timeline.from(entryCurrent, {
                        y: `${translateY}px`,
                        duration: this.$store.state.transition.project.duration.video
                    }, "descente")
                    //- Démasquage du nom
                    timeline.addLabel("demask")
                    timeline.from(entryCurrentName, {
                        y: -50,
                        opacity: 0,
                        duration: this.$store.state.transition.project.duration.other
                    }, "demask")
                }
            //: SINON ...
            } else {
                done()
            }
        },
        //! Après l'animation de la page ciblée
        onAfterEnter(){
            //* On install les scroll trigger
            if(this.$store.state.load !== false && this.music == true){
                this.$nextTick(() => {
                    this.$refs.musicCase.installScroller()
                })
            }
            
            if(this.$store.state.load !== false && this.$route.meta.text == "Projet"){
                //- On joue la vidéo
                const entryCurrentVideo = document.querySelector(".entry_current .entry__media__item")
                entryCurrentVideo.play()
            }
            //: Déblocage du scroll
            this.$store.dispatch("deblockScrollStyle")
        },
        //! Fonction qui determine si on est sur mobile ou desktop ($big-mobile-change JS)
        derminateVersion(){
            if(window.innerWidth > this.mobile.size){
                this.mobile.actived = false
            } else {
                this.mobile.actived = true
            }
        },
        //! Détecter si on navigue un navigateur mobile ou desktop
        detectNavigator(){
            window.mobileCheck = function() {
                let check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            }
            const isMobileNavigator = window.mobileCheck()
            
            this.$store.commit("SET_MOBILE_NAVIGATOR", isMobileNavigator)
        },
        //! Choisit la vidéo la plus adapter pour chaque projet
        videoResponsive(){
            const listOfProject = this.$store.state.listOfProject
            
            for (let i = 0; i < listOfProject.length; i++) {
                let index
                const listOfMedia = listOfProject[i].media.listOfVideo
                for (let y = 0; y < listOfMedia.length; y++) {
                    if(window.innerWidth <= listOfMedia[y].media){
                        index = y
                    }
                }
                const payload = {
                    indexOfProject: i,
                    indexOfMedia: index
                }
                this.$store.commit("SET_VIDEO_RESPONSIVE", payload)
                
            }
        },
        //! Choisit la vidéo la plus adapter pour chaque projet
        paralax1Responsive(){
            const listOfProject = this.$store.state.listOfProject
            
            for (let i = 0; i < listOfProject.length; i++) {
                let index
                const listOfMedia = listOfProject[i].media.listOfParalax1
                for (let y = 0; y < listOfMedia.length; y++) {
                    if(window.innerWidth <= listOfMedia[y].media){
                        index = y
                    }
                }
                const payload = {
                    indexOfProject: i,
                    indexOfMedia: index
                }
                this.$store.commit("SET_PARALAX1_RESPONSIVE", payload)
                
            }
        }
    },
    created(){
        this.derminateVersion()
        this.videoResponsive()
        this.paralax1Responsive()
        this.$store.dispatch("sizeOfWindow")
        this.detectNavigator()
        window.addEventListener("resize", () => {
            this.derminateVersion(false)
            this.videoResponsive()
            this.paralax1Responsive()
        })
        
    },
}
</script>

<style lang="scss">
    @import '@/sass/utils/variable.scss';
    @import '@/sass/utils/function.scss';
    @import '@/sass/base/font.scss';
    @import '@/sass/base/reset.scss';
    @import '@/sass/base/base.scss';
    .app{
        position: relative;
        width: 100%;
        height: 100%;
    }
    @media only screen and (max-width: $mobile-big-change) {
        *{
            cursor: default;
        }
    }
</style>